var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewsClick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M407.338 938.526C410.845 938.526 412.599 938.526 416.106 938.526L836.955 938.526C894.822 938.526 942.168 870.32 942.168 786.958L942.168 757.517C942.168 745.874 933.878 736.435 923.653 736.435L522.298 736.435C512.072 736.435 503.783 745.874 503.783 757.517L503.783 786.958C503.783 865.268 461.698 930.948 407.338 938.526Z",
    fill: "#ff915a",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.435 938.526C842.313 938.526 840.752 938.526 837.63 938.526L462.998 938.526C411.486 938.526 369.34 870.32 369.34 786.958L369.34 757.517C369.34 745.874 376.719 736.435 385.822 736.435L743.1 736.435C752.203 736.435 759.582 745.874 759.582 757.517L759.582 786.958C759.582 865.268 797.045 930.948 845.435 938.526Z",
    fill: "#ffd1c1",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.333 938.526C592.211 938.526 590.65 938.526 587.528 938.526L212.896 938.526C161.385 938.526 119.238 870.32 119.238 786.958L119.238 757.517C119.238 745.874 126.617 736.435 135.72 736.435L492.999 736.435C502.101 736.435 509.48 745.874 509.48 757.517L509.48 786.958C509.48 865.268 546.943 930.948 595.333 938.526Z",
    fill: "#ffd1c1",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.238 799.366L759.238 146.34C759.238 119.956 738.609 98.5679 713.161 98.5679L165.316 98.5679C139.868 98.5679 119.238 119.956 119.238 146.34L119.238 798.446C119.238 838.158 198.238 939.526 232.238 939.526L639.238 939.526C705.239 939.526 759.238 876.454 759.238 799.366Z",
    fill: "#ffd1c1",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.839 752.523L495.164 751.783",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.281 235.863L446.802 235.863C451.835 235.863 455.916 238.997 455.916 242.863L455.916 447.063C455.916 450.929 451.835 454.063 446.802 454.063L188.281 454.063C183.247 454.063 179.167 450.929 179.167 447.063L179.167 242.863C179.167 238.997 183.247 235.863 188.281 235.863Z",
    fill: "#82c1ff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.407 569.824L688.214 569.824C691.209 569.824 693.636 572.958 693.636 576.824L693.636 781.025C693.636 784.891 691.209 788.025 688.214 788.025L534.407 788.025C531.413 788.025 528.985 784.891 528.985 781.025L528.985 576.824C528.985 572.958 531.413 569.824 534.407 569.824Z",
    fill: "#82c1ff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.33 258.132L705.669 258.57",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.839 508.136L688.084 508.575",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.33 318.245L705.669 320",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.839 572.249L492.75 574.286",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.33 379.236L705.669 378.358",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.839 633.452L493.167 632.362",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.33 437.594L705.669 436.716",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.839 691.46L495.164 690.72",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.118 133.929L333.118 133.929C345.37 133.929 355.302 148.48 355.302 166.429L355.302 166.429C355.302 184.378 345.37 198.929 333.118 198.929L333.118 198.929C320.866 198.929 310.933 184.378 310.933 166.429L310.933 166.429C310.933 148.48 320.866 133.929 333.118 133.929Z",
    fill: "none",
    opacity: 1,
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.67 133.929L399.67 133.929C411.922 133.929 421.854 148.48 421.854 166.429L421.854 166.429C421.854 184.378 411.922 198.929 399.67 198.929L399.67 198.929C387.418 198.929 377.486 184.378 377.486 166.429L377.486 166.429C377.486 148.48 387.418 133.929 399.67 133.929Z",
    fill: "none",
    opacity: 1,
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.223 133.929L466.223 133.929C478.475 133.929 488.407 148.48 488.407 166.429L488.407 166.429C488.407 184.378 478.475 198.929 466.223 198.929L466.223 198.929C453.971 198.929 444.038 184.378 444.038 166.429L444.038 166.429C444.038 148.48 453.971 133.929 466.223 133.929Z",
    fill: "none",
    opacity: 1,
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.62 133.929L537.62 133.929C549.872 133.929 559.805 148.48 559.805 166.429L559.805 166.429C559.805 184.378 549.872 198.929 537.62 198.929L537.62 198.929C525.368 198.929 515.436 184.378 515.436 166.429L515.436 166.429C515.436 148.48 525.368 133.929 537.62 133.929Z",
    fill: "none",
    opacity: 1,
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsClick);
export default __webpack_public_path__ + "static/media/NewsClick.164ceb6b5150bfade584b6375a599b7f.svg";
export { ForwardRef as ReactComponent };